import React from 'react';
import partnerInfo from "../../utils/partnersInfo";

function Clients() {
    return (
        <section className="row_am our_client">
            <div className="container">
                <div className="section_title" data-aos="fade-up" data-aos-duration={1500}>
                    <span className="title_badge">Partenerii noștrii</span>
                    <h2>
                        Fac parte din
                        <span className="d-block">Povestea LUMO</span>
                    </h2>
                </div>
                <ul className="client_list">
                    {partnerInfo.map(({ logo, link }, index) => (
                        <li key={index}>
                            <div className="client_logo" data-aos="fade-up" data-aos-duration={1500}>
                                <a href={link} target="_blank" rel="noopener noreferrer">
                                    <img
                                        src={logo}
                                        alt="logo"
                                        className={`partner-logo partner-logo-${index}`}
                                    />
                                </a>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
}

export default Clients;